import { TR_MESSAGES, type ErrorCode } from '@shared/api-errors';

/**
 * Login akışı raw fetch kullanır (axios interceptor'ı ve ApiError'ı bypass eder),
 * bu yüzden problem+json gövdesini burada elle TR mesajına çevirir. Bilinmeyen
 * kod / problem-dışı gövde → undefined; çağıran kendi fallback'ini gösterir.
 */
export function resolveLoginErrorMessage(body: unknown): string | undefined {
  if (!body || typeof body !== 'object') return undefined;
  const code = (body as { code?: unknown }).code;
  if (typeof code !== 'string') return undefined;
  return TR_MESSAGES[code as ErrorCode];
}
